import { MouseEvent, memo } from 'react';

import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { useRouter } from '@flipster/i18n/routing';
import { TableCell } from '@flipster/ui/Table';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { getSymbolPathname } from '@web/app/[locale]/(web)/trade/_misc/pathname';

interface Props {
  symbol: string;
  index: number;
  tradeType: 'perpetual' | 'spot';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const SymbolIconCell = memo(({ symbol, tradeType, index, onClick }: Props) => {
  const router = useRouter();

  const isSpot = tradeType === 'spot';

  return (
    <TableCell>
      <button
        type='button'
        value={symbol}
        onClick={(e) => {
          router.push(getSymbolPathname(symbol, isSpot));
          segment.track(TradeEvent.TradeCryptoClick, {
            trade_type: tradeType,
            carousel_type: isSpot ? 'Your holdings' : 'Your positions',
            symbol,
            list_order: index,
            search_type: null,
            search_word: null,
            price_change_percentage: null,
          });
          onClick?.(e);
        }}
      >
        <SymbolDisplay
          symbol={symbol}
          icon={<SymbolDisplay.Icon size={16} />}
          mainLabel={
            <SymbolDisplay.Label
              value='shortName'
              css={{ textStyle: 'Text/S/Strong', color: 'content.default.level-5' }}
            />
          }
        />
      </button>
    </TableCell>
  );
});
